import { groq } from "next-sanity"

import { groqQueryOptions } from "@/graphql/schemas/shared/utils/groqQueryOptions"
import { AppSettings } from "@/settings"

import { checkPermissions } from "../../shared/permissions/permissions"
import { DomainObjects, Operations } from "../../shared/permissions/permissionsConfig"
import { specialOfferProjection } from "../sanity/specialOffer.projection"

export const querySpecialOffers = {
  async specialOffers(_parent, args, context, _info) {
    const { lang = AppSettings.defaultLocale(), cdn = true, offset, limit, sort, sortWithinLimits } = args
    const { user } = context

    await checkPermissions({
      user,
      domainObject: DomainObjects.SPECIAL_OFFERS,
      operation: Operations.READ,
    })

    const config = AppSettings.sanityConfigByLang(lang)
    const client = context.sanityClient
    client.config({ ...config, useCdn: cdn })

    const { pipesAndLimits, draftsFilter } = groqQueryOptions({
      sort,
      offset,
      limit,
      sortWithinLimits,
      includeDrafts: true,
    })

    //TODO: attachments and attachmentFiles are of type json response. Check what is needed and define better types
    const specialOffers = await client.fetch(
      groq`{
        "total": count(*[_type=="specialOffer"]),
        "items": *[_type=="specialOffer" ${draftsFilter}]${pipesAndLimits}{
          ${specialOfferProjection()}
        }
      }`,
    )

    if (specialOffers.items && specialOffers.items.length !== 0) {
      // Visibility options - EINZA-1737
      const visibleItems = specialOffers.items.filter((item) => {
        const isVisibleForUserGroups = item.visibleUserGroups?.includes(user?.role)
        const isVisibleForEmployees = item.visibleEmployees?.some((adm) => adm.admNumber === user?.employeeNumber)
        return (!item.visibleUserGroups && !item.visibleEmployees) || isVisibleForUserGroups || isVisibleForEmployees
      })

      return { items: visibleItems }
    }

    return null
  },
}
